import { render, staticRenderFns } from "./EditVendor.vue?vue&type=template&id=4b542fb3"
import script from "./EditVendor.vue?vue&type=script&lang=ts"
export * from "./EditVendor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports